
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { Post } from "@/models";

export default {
name: "addFeihuaTopicReplyPopup",
created() {},
props: ["value", "topic"],
data() {
return {
reply: ""
};
},
computed: {},
methods: {
onShow: function() {



},

submit: function() {
let reply = (this.reply || "").trim();

if (!reply) {
return;
}
this.topic
.addFeihuaReply(reply)
.then(response => {
let result = response.result;

if (result == 0) {
this.$vux.toast.text("飞花成功", "middle");
this.$emit("input", false);
this.$emit("submit", response.topicReply);
} else if (result == 1) {
this.$vux.toast.text("未匹配到相关的古诗词", "middle");
} else if (result == 2) {
this.$vux.toast.text(
"飞花内容必须包含「" + this.topic.get("keyword") + "」字",
"middle"
);
} else if (result == 3) {
this.$vux.toast.text("飞花内容至少 5 个字", "middle");
} else if (result == 4) {
this.$vux.toast.text("此句在不久前被人发过啦", "middle");
} else {
this.$vux.toast.text("接龙失败，错误码：" + result, "middle");
}
})
.catch(err => {
this.$vux.toast.text("接龙失败", "middle");
});
},

close: function() {
this.$emit("input", false);
}
},
components: {
Popup,
XButton,
XTextarea,
Group
}
};



// WEBPACK FOOTER //
// ./src/components/topic/AddFeihuaTopicReplyPopup.vue